import { Injectable } from '@angular/core';
import { CalendarEntryDTO, PlayerCullDTO } from './api/api';

@Injectable({
  providedIn: 'root',
})
export class CommercialReservationService {
  playerCull: PlayerCullDTO;
  entry: CalendarEntryDTO;

  constructor() {
    this.resetService();
  }

  resetService() {
    this.entry = null;
    this.playerCull = null;
  }
}
